import { Button } from '@gravity-ui/uikit';
import { useLazyDownloadAllStatosticReportQuery, useLazyDownloadChangelogReportQuery } from 'store/api';
import styles from './styles.module.scss';

export const StatisticReport = () => {
	const [trigger, { isFetching }] = useLazyDownloadChangelogReportQuery();
	const [triggerAllStatistic, { isFetching: isFetchingAllStatistic }] = useLazyDownloadAllStatosticReportQuery();

	const handleDownload = async () => {
		try {
			const result = await trigger().unwrap();
			const url = window.URL.createObjectURL(result);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Отчет об изменениях.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Ошибка при скачивании файла:', error);
		}
	};

	const handleDownloadA = async () => {
		try {
			const result = await triggerAllStatistic().unwrap();
			const url = window.URL.createObjectURL(result);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Сводная таблица.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Ошибка при скачивании файла:', error);
		}
	};
	return (
		<div className={styles.chart}>
			<h2>Отчет об изменениях и общая сводная таблица</h2>
			<Button onClick={handleDownload} loading={isFetching} size="xl">
				{isFetching ? 'Скачивание...' : 'Скачать отчёт об изменениях'}
			</Button>
			<Button onClick={handleDownloadA} loading={isFetchingAllStatistic} size="xl">
				{isFetchingAllStatistic ? 'Скачивание...' : 'Скачать сводную таблицу'}
			</Button>
		</div>
	);
};
